import styled from 'styled-components'

import { Button } from '../../../components/atoms/Button/Button'
import { styleMixins } from '../../../style'

const { getSpacing } = styleMixins.offset
const { defaultTitleStyle, defaultTextStyle } = styleMixins.text

export const SContentPanel = styled.div`
  display: flex;
`

export const MapWrapp = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  z-index: -1;
`

export const MenuWrapp = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  svg {
    transform: rotate(180deg);
  }
`

export const MenuWrappText = styled.div`
  padding: 8px;
  display: flex;
  justify-content: center;
  background-color: ${(p) => p.theme.colors.grey_000};
  margin-right: 32px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  cursor: pointer;
`

export const TextWrapp = styled.p`
  ${defaultTitleStyle(3)}
`

export const SCardContainer = styled.div`
  display: flex;
  position: fixed;
  flex-direction: column;
  margin: ${getSpacing([3, 0, 0, 4])};
  max-width: 292px;
  z-index: 1;

  .ant-input-affix-wrapper:hover {
    border: 1px solid ${(p) => p.theme.colors.blue_500};
  }

  .ant-input-affix-wrapper > input.ant-input {
    border-radius: ${(p) => p.theme.decoration.borderRadius.smaller};
  }

  @media ${(p) => p.theme.breakpoints.desktop} {
    margin: ${getSpacing([10, 0, 0, 2])};
  }
  @media ${(p) => p.theme.breakpoints.mobile} {
    margin: ${getSpacing([10, 0, 0, 1])};
  }
`

export const SButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${getSpacing(1)};
  margin-top: ${getSpacing(2)};

  .size--small {
    ${defaultTextStyle(9)}
  }

  @media ${(p) => p.theme.breakpoints.mobile} {
    flex-direction: row;
    bottom: 25px;
    position: fixed;
  }
`

export const SButton = styled(Button)<{ active: boolean }>`
  background-color: ${(p) =>
    p.active ? p.theme.colors.blue_500 : p.theme.colors.grey_000};
  color: ${(p) =>
    p.active ? p.theme.colors.grey_000 : p.theme.colors.grey_600};
`

export const SBreadcrumbsFilter = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  justify-content: center;
  z-index: 1;
  gap: ${getSpacing(3)};
  padding: ${getSpacing(2)};

  @media ${(p) => p.theme.breakpoints.desktop} {
    width: 100%;
    align-items: center;
    justify-content: center;
    max-width: 500px;
    right: 0;
    margin-top: ${getSpacing(1)};
  }
`

export const BreadcrumbItem = styled.div`
  display: flex;
  border-radius: ${(p) => p.theme.decoration.borderRadius.default};
  background-color: ${(p) => p.theme.colors.blue_500};
  padding: ${getSpacing(0.5)} ${getSpacing(2)};
  color: ${(p) => p.theme.colors.grey_000};

  @media ${(p) => p.theme.breakpoints.mobile} {
    margin-top: ${getSpacing(1)};
    min-width: 25px;
    justify-content: center;
    align-items: center;
    min-height: 50px;
  }
`

export const LocalityMapPanel = styled.div`
  background-color: ${(p) => p.theme.colors.grey_000};
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  > div {
    border: 0;
    padding-bottom: 0;
    gap: 8px;
  }
`
